<template>
	<div class="panel">
		<Header class="panel__header" />

		<section class="panel__content">
			<ErrorView v-if="error" />
			<VoicesView v-else />
		</section>

		<Footer class="panel__footer" />

		<Processing
			v-if="isProcessing"
			class="panel__processing"
		/>
	</div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';

import Processing from '../components/Processing.vue';
import { useTwitchExtListeners } from '../composables/useTwitchExtListeners';
import Footer from '../sections/Footer.vue';
import Header from '../sections/Header.vue';
import { useStore } from '../store';
import { TwitchExtensionInitializationError } from '../types/errors';
import ErrorView from '../views/ErrorView/ErrorView.vue';
import { VoicesView } from '../views/VoicesView';

const { registerTwitchExtListeners } = useTwitchExtListeners();
const store = useStore();
const { error, isProcessing } = storeToRefs(store);

onMounted(() => {
	try {
		registerTwitchExtListeners();
	} catch (error) {
		TwitchExtensionInitializationError.report({
			description: 'Error registering twitch extension listeners',
			cause: error,
		}).debug();
	}

	store.startInitializationTimeout();
});
</script>

<style lang="scss">
.panel {
	position: relative;

	overflow: hidden;
	display: flex;
	flex-direction: column;

	max-width: 800px;
	height: 100vh;
	max-height: 500px;

	&__header {
		z-index: 200;
		top: 0;
	}

	&__content {
		overflow: hidden auto;
	}

	&__footer {
		position: absolute;
		z-index: 100;
		bottom: 0;
		width: 100%;
	}

	&__processing {
		position: absolute;
		z-index: 150;
		top: 0;
		left: 0;

		width: 100%;
		height: 100%;
	}
}
</style>
